/* eslint-disable react/prop-types */
import React from 'react';

import ColumnFilterSort from '../../components/tableClientSide/ColumnFilterSort';

import ProductImage from '../../components/aurora/ProductImage';

export const getProductColumns = () => {
  return [
    {
      Header: 'Image',
      id: 'image',
      accessor: d => d.productCode,
      Cell: ({ value }) => (
        <div className='u-full-width d-sm-flx flx-jc-sm-c'>
          <ProductImage productCode={value} alt={value} width={35} height={35} magnify />
        </div>
      ),
      width: 50
    },
    {
      Header: ({ column }) => <ColumnFilterSort header='Name' column={column} />,
      accessor: 'name',
      Cell: ({ value }) => <div>{value?.toUpperCase()}</div>
    },
    {
      Header: ({ column }) => <ColumnFilterSort header='Product Code' column={column} />,
      accessor: 'productCode'
    },
    {
      Header: ({ column }) => <ColumnFilterSort header='Is Returnable' column={column} />,
      accessor: 'isReturnable',
      Cell: ({ value }) => (value ? 'Yes' : 'No'),
      sortType: 'basic',
      filter: 'yesNo'
    },
    {
      Header: ({ column }) => <ColumnFilterSort header='Sales Org' column={column} />,
      accessor: 'salesOrganizationCode'
    }
  ];
};
